export const NAVIGATE = {
  SERVICES: "/patient/services",
};
